import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ element, ...rest }) => {
    const user = useSelector((state) => state.auth.user);
    console.log(user);
    // If the user is not logged in, redirect to login page
    if (!user) {
        
        return <Navigate to="/login" />;
    }

    return element; // If the user is logged in, return the protected element
};

export default ProtectedRoute;
